import type { ProductCenterRow } from '@/modules/zy-crm/components/product-center-form-section';

export type ProductRow = ProductCenterRow;

const firstNonEmptyText = (...values: unknown[]) => {
  for (const value of values) {
    if (value === undefined || value === null) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return '';
};

const toNumber = (value: unknown) => {
  const next = Number(value ?? 0);
  return Number.isFinite(next) ? next : 0;
};

const toAmount = (value: number, precision = 2) => value.toFixed(precision);

export const mapOpportunityProductToRow = (
  item: any,
  fallbackKey: string,
): ProductRow => ({
  key: String(item?.uuid || item?.offeringVersionUuid || fallbackKey),
  uuid: item?.uuid,
  offeringUuid: item?.offeringUuid,
  offeringVersionUuid: item?.offeringVersionUuid,
  productName: firstNonEmptyText(item?.productName, item?.name),
  productCode: item?.productCode,
  productType: firstNonEmptyText(item?.productType),
  productUnit: firstNonEmptyText(item?.productUnit, item?.unitName, item?.unit),
  versionNo: item?.versionNo,
  standardPrice: String(item?.standardPrice ?? '0'),
  selectionSnapshot: item?.selectionSnapshot,
  quotePrice: String(item?.opportunityPrice ?? '0'),
  quantity: String(item?.quantity ?? '1'),
  totalPrice: String(item?.totalPrice ?? '0'),
  rowSort: item?.rowSort,
  remark: item?.remark,
});

export const toQuoteApiProductRow = (row: ProductRow) => ({
  offeringUuid: row.offeringUuid,
  offeringVersionUuid: row.offeringVersionUuid,
  productName: row.productName,
  productCode: row.productCode,
  productType: row.productType,
  productUnit: row.productUnit,
  versionNo: row.versionNo,
  standardPrice: toAmount(toNumber(row.standardPrice), 6),
  selectionSnapshot: row.selectionSnapshot,
  quotePrice: toAmount(toNumber(row.quotePrice)),
  quantity: toAmount(toNumber(row.quantity)),
  totalPrice: toAmount(toNumber(row.quotePrice) * toNumber(row.quantity)),
  rowSort: row.rowSort,
  remark: row.remark || undefined,
});
